<!-- 数据获取设置  --- 数据获取设置明细-->
<template>
  <div class="tableShow">
    <Table
       ref="table"
      :loadObj='{}'
      :option="{}"
      :colObj='{
        opId:"3289",
        name:"数据获取设置明细",
        parentId:"GET_ID",
        parentName:"数据获取设置",
        parentPath:"/system/getData",
        parentQuery:{
        },
        addForm:{
        },
        dataClass:2,
        col:[]
      }'
    >
    </Table>
  </div>
</template>

<script>
import Table from "@/components/table/dataTablecSon";
export default {
  components: {
    Table,
  },
  data() {
    return {
        firstEnter:true
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  activated() {
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  },
};
</script>

<style></style>